import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    subjectFieldId: String,
    editorId: String,
    defaultContent: String,
    additionalInstructionsFieldId: String
  }

  populate(event) {
    const option = event.target.selectedOptions[0];
    
    const subject = option?.dataset.subject || '';
    const content = option?.dataset.front || this.defaultContentValue || '';
    const additionalInstructions = option?.dataset.additionalInstructions || '';
    
    this.updateSubject(subject);
    this.updateEditor(content);
    this.updateAdditionalInstructions(additionalInstructions);
  }
  
  updateSubject(value) {
    const field = document.getElementById(this.subjectFieldIdValue);
    if (field) field.value = value;
  }

  updateAdditionalInstructions(value) {
    if (!this.hasAdditionalInstructionsFieldIdValue) return;
    const field = document.getElementById(this.additionalInstructionsFieldIdValue);
    if (field) {
      field.value = value;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  updateEditor(content) {
    const editor = document.getElementById(this.editorIdValue);
    if (!editor) return;
    
    const container = editor.closest('.rich_text_editor_component');
    if (!container) return;
    
    const quillEditor = editor.querySelector('.ql-editor');
    const hiddenInput = container.querySelector('input[type="hidden"]');
    if (!quillEditor || !hiddenInput) return;
    
    quillEditor.innerHTML = content;
    hiddenInput.value = content;
    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

}
